module.exports = {"id":"173731","name":"Gareth Bale","rating":"88","photo":"./data/images/photos/0/173731.png","club":{"name":"Real Madrid","logo":"./data/images/clubs/RealMadrid.png"},"positions":["AD","BU","AG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GarethBale0.json
// module id = 1529
// module chunks = 0